import React from 'react';
import TableCoreComponent from './../../reusable/LightTable/TableCoreComponent';
import { PermissionContext, withPermission } from './../../context';
import { userHas, permissions } from "../../permissions";
import { FormattedMessage, injectIntl } from 'react-intl';
import utils from './../../utils/utilities';
import headerActions from './../../reusable/Header/Header.actions';
import reduxStore from './../../reduxStore';
import api from '../../api/Entities.api';
import categoriesApi from './../../api/Categories.api';
import { ListingPageHeaderPerm as ListingPageHeader, ActiveLabel } from './../../reusable/LightTable/Components'
import actions from './../ReviewCompanies/ReviewCompanies.actions';
import {
    ENTITIES_PAGE_SIZE,
    PAGE_NAME_MANAGE_ENTITIES,
    ENTITIES_HOT_UPDATE_LIMIT,
    FILTER_TYPE_DROPDOWN,
    ENTITIES_DOWNLOAD_OPTIONS
} from './../../constants';
import { BoldedCell, TextCell, ActionItemsCell } from './../../reusable/LightTable/Components';
import withSort from './../../reusable/LightTable/hoc/Sortable';
import withSearch from './../../reusable/LightTable/hoc/Searchable';
import withSelectionPaginated from './../../reusable/LightTable/hoc/SelectablePaginated';
import withPagination from './../../reusable/LightTable/hoc/Paginated';
import withFixedHeader from './../../reusable/LightTable/hoc/withFixedHeader';
import LightTable from './../../reusable/LightTable/VeryLightTable';
import { DeleteButton, ActionLink, BulkActivateButton, BulkDownloadButton } from './../../reusable/Form/Buttons';
import { compose } from 'redux';
import {DateCell} from "../../reusable/LightTable/Components";
import EntityCategoriesPillList from "./components/EntityCategoriesPillList";
import Spinner from "../../reusable/Spinner/Spinner";
import AddNewCategoryModal from './../../reusable/ReusableModals/AddNewCategoryModal/AddNewCategoryModal.index.jsx';
import { sortBy, toLower } from 'lodash';
import {
    ModalReviewPageRemovedCategoryIsOrphaned,
    ModalReviewPageRemovedCategoryIsOrphanedLinked,
    ModalDeleteEntityOrphanedCategories,
    ModalBulkDeleteEntityOrphanedCategories
} from './../../reusable/Modal/ModalBodies';
import AssignToCategory from "./components/AssignToCategory";
import FileDownload from "../AccountUsage/Components/FileDownload";
import dateFormat from 'dateformat';
import EntitiesDownloadModal from "./components/EntitiesDownloadModal";
import {ENTITIES_DOWNLOAD_REPORT_ENDPOINT} from "../../constants";

const Table = compose(
    withPermission,
    withSelectionPaginated,
    withSort,
    withSearch,
    withPagination,
    withFixedHeader
)(LightTable);

export class EntityListing extends TableCoreComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            categories: null,
            downloadParams: false
        }

        const defaultLoadParams = {
            filters:    {query: "", categoryIdFilter: "defaultAllCategories", active: "all"},
            sorting:    reduxStore.getState().user.preferences.pagesTablesSort[PAGE_NAME_MANAGE_ENTITIES],
            pagination: {pageNumber: 0, pageSize: ENTITIES_PAGE_SIZE},
            reset:      false
        };
        this.defaultLoadParams = this.loadParams = defaultLoadParams;
        this.api = api;

        this.handleUnassignCategory = this.handleUnassignCategory.bind(this);
        this.handleBulkDelete = this.handleBulkDelete.bind(this);
        this.handleAssignCategory = this.handleAssignCategory.bind(this);
        this.handleAddNewCategory = this.handleAddNewCategory.bind(this);
        this.handleBulkActive = this.handleBulkActive.bind(this);
        this.handleBulkDownload = this.handleBulkDownload.bind(this);
        this.handleDownloadComplete = this.handleDownloadComplete.bind(this);
        this.deleteSelectedEntities = this.deleteSelectedEntities.bind(this);
    };

    componentDidMount() {
        headerActions.updateHeader('thirdPartyListing');
        this.updateCategoriesName(() => {
            const categoryIdFilter = utils.getSingleCategoryFilter(reduxStore.getState().user.preferences.filters.entitiesFilter, this.state.categories);
            this.loadItems({ filters: { categoryIdFilter } });
        });
    };

    headerItems = [
        {
            key: "companyTitle",
            label: <FormattedMessage id='Entities_Edit_UIText_thirdPartyListing.titleColumnHeading'/>,
            sortable: true,
            persistableSort: PAGE_NAME_MANAGE_ENTITIES
        },
        {
            key: "customerCompanyId",
            label: <FormattedMessage id='Entities_Edit_UIText_thirdPartyListing.thirdPartyIdColumnHeading'/>,
            sortable: true,
            persistableSort: PAGE_NAME_MANAGE_ENTITIES
        },
        {
            key: "dunsNumber",
            label: <FormattedMessage id={"Entities_Review_Error_errorCompanies.CompanyDuns"}/>
        },
        {
            key: "experianBusinessId",
            label: <FormattedMessage id={"Entities_Review_Error_errorCompanies.CompanyExperian"}/>
        },
        {
            key: "active",
            label: <FormattedMessage id={"Entities_Edit_UIText_thirdPartyListing.statusColumnHeading"}/>
        },
        {
            key: "categoryIDs",
            label: <FormattedMessage id={"Entities_Edit_UIText_thirdPartyListing.categoriesColumnHeading"}/>
        },
        {
            key: "createdDate",
            label: <FormattedMessage id={"Entities_Review_UIText_reviewCompanies.uploadDate"}/>,
            sortable: true,
            persistableSort: PAGE_NAME_MANAGE_ENTITIES
        },
        {
            key: "actions",
            label: ""
        }
    ];

    /**
     * View function for items in table
     * @param item
     * @param searchTerm
     * @returns {{key, companyTitle: XML, status: string, duns: (string|string|*), categoryIDs: XML, object: *}}
     */
    formatItem = (item, searchTerm = "") => {
        return {
            key: item.id,
            companyTitle: <BoldedCell value={item.companyTitle} searchTerm={searchTerm} />,
            customerCompanyId: <BoldedCell value={item.customerCompanyId} searchTerm={searchTerm} />,
            dunsNumber: <BoldedCell value={item.dunsNumber} searchTerm={searchTerm} />,
            experianBusinessId: <BoldedCell value={item.experianBusinessId} searchTerm={searchTerm} />,
            active: <TextCell><ActiveLabel isActive={item.active}/></TextCell>,
            categoryIDs: <Spinner isLoading={this.state.categories === null}>
                    <EntityCategoriesPillList categories={this.getCategories(item.categoryIDs)}
                                              onRemoveEntity={this.handleUnassignCategory}
                                              entity={item} />
                </Spinner>,
            createdDate: <DateCell timestamp={item.createdDate}/>,
            actions: <ActionItemsCell>
                <ActionLink to={"/edit-third-party/" + item.id}>
                    <FormattedMessage id="General_CoreFunctionality_UIText_general.edit" />
                </ActionLink>
            </ActionItemsCell>,
            object: item
        }
    };

    formatSelectedItem = (item) => <span>{item.companyTitle}</span>;

    getCategories(categoryIDs) {
        if (this.state.categories) {
            return categoryIDs.map(categoryID => {
                if (this.state.categories[categoryID]) {
                    return { id: categoryID, label: this.state.categories[categoryID] }
                } else {
                    console.log("ERROR -- Category label not found in list");
                    return { id: null, label: "[Not found]" };
                }
            })
        } else {
            return []
        }
    }

    getFilters() {
        let categories = [{
            label: this.props.intl.formatMessage({ id: "Entities_Review_UIText_reviewCompanies.allCategories" }),
            value: "defaultAllCategories"
        }];
        if (this.state.categories) {
            categories = [];
            for (let id in this.state.categories) {
                categories.push({
                    label: this.state.categories[id],
                    value: id
                });
            }
            categories = categories.sort((a, b) => toLower(a.label) > toLower(b.label) ? 1 : -1)
            categories = [
                {
                    label: this.props.intl.formatMessage({ id: "Entities_Review_UIText_reviewCompanies.allCategories" }),
                    value: "defaultAllCategories"
                }, ...categories ];
        }
        return [
            {
                type: FILTER_TYPE_DROPDOWN,
                label: <FormattedMessage id={"Entities_Edit_UIText_editThirdParty.statusLabel"}/>,
                field: "active",
                options: [
                    { label: this.props.intl.formatMessage({ id: "Entities_Edit_UIText_thirdPartyListing.all" }), value: "all" },
                    { label: this.props.intl.formatMessage({ id: "Entities_Edit_UIText_thirdPartyListing.active" }), value: "active" },
                    { label: this.props.intl.formatMessage({ id: "Entities_Review_Error_thirdPartyListing.inactive" }), value: "non-active" },
                ],
                value: this.loadParams.filters.active,
                default: "all"
            },
            {
                type: FILTER_TYPE_DROPDOWN,
                label: <FormattedMessage id={"Entities_Review_UIText_reviewCompanies.categories"}/>,
                field: "categoryIdFilter",
                options: categories,
                value: this.loadParams.filters.categoryIdFilter,
                default: "defaultAllCategories",
                onChange: utils.setCategoryPersistenceFilter
            }
        ]
    }

    updateCategoriesName(callback = null) {
        categoriesApi.getCategoryNames().then(categories => {
            this.setState({ categories });
            if (callback) {
                callback()
            }
        }).catch((e) => {
            this.fatalError(e);
        });
    }

    handleBulkDelete() {
        let activeModal
        if (this.state.selectedItems.length === 1) {
            activeModal = (
                <ModalDeleteEntityOrphanedCategories
                    isModalLoading={false}
                    primaryAction={this.deleteSelectedEntities}
                    secondaryAction={this.closeModal}
                    categoryName={this.state.selectedItems[0].companyTitle} />
            )
        } else {
            activeModal = (
                <ModalBulkDeleteEntityOrphanedCategories
                    isModalLoading={false}
                    primaryAction={this.deleteSelectedEntities}
                    secondaryAction={this.closeModal}
                    selectedEntitiesCount={this.state.selectedItems.length} />
            )
        }
        this.setState({ activeModal })
    }

    deleteSelectedEntities() {
        api.deleteEntities(this.state.selectedItems.map(item => item.object.id)).then(() => {
            this.clearSelections();
            this.reloadTable();
            this.showSuccessPopup("Entities_Review_UIText_reviewCompanies.selectedCompaniesDeleted");
        }).catch(e => {
            this.clearSelections();
            this.showGenericError(e, true);
        })
    }

    handleUnassignCategory(entity, category) {
        categoriesApi.getCategoryData(category.id).then(response => {
            if (response.body.companies && response.body.companies.length > 1) {
                this.unassignCategoryFromCompany(entity, category);
            } else {
                let props = { categoryName: category.label, categoryId: category.id, entityName: entity.companyTitle, isModalLoading: true };
                this.toggleCheckCategoryBeforeDeleteConfirmation(props);
                utils.checkCategoryLinks(category.id)
                    .then((response) => {
                        props.isModalLoading = false;
                        props.primaryAction = () => {
                            this.closeModal();
                            this.unassignCategoryFromCompany(entity, category).then(() => {
                                if (this.loadParams.filters.categoryIdFilter === category.id) {
                                    // if the category that is about to be removed is filtered by, reset filters and get new category list
                                    this.updateCategoriesName();
                                    this.loadItems(this.defaultLoadParams);
                                }
                            });
                        };
                        if(response.count > 0) {
                            props.totalCount = response.count;
                            props.listItems = response.list;
                            this.toggleCheckCategoryBeforeDeleteWithTableConfirmation(props);
                        } else {
                            this.toggleCheckCategoryBeforeDeleteConfirmation(props);
                        }
                    });
            }
        })
    }

    handleAssignCategory(categoryId) {
        const selectedItemsObjects = this.state.selectedItems.map(item => item.object);
        const entityIds = selectedItemsObjects.map(item => item.id);
        if (categoryId !== "addNewCategory") {
            this.setItemsLoading(selectedItemsObjects, true);

            api.assignCategoryToEntity(categoryId, entityIds).then(() => {
                this.refreshEntityItems(selectedItemsObjects);
                this.showSuccessPopup("Entities_Review_UIText_reviewCompanies.categoryAssignmentSuccessful")
            }).catch(e => {
                this.clearSelections();
                this.showGenericError(e, true);
            })
        } else {
            const activeModal = <div className={"review-companies-page"}>
                <AddNewCategoryModal companies={entityIds}
                                     categories={this.state.categories}
                                     addNewCategory={this.handleAddNewCategory}
                                     toggleAddNewCategoryModal={this.closeModal} />
            </div>
            this.setState({ activeModal });
        }
    }

    handleAddNewCategory(category, entities) {
        const selectedItemsObjects = this.state.selectedItems.map(item => item.object);
        this.setItemsLoading(selectedItemsObjects, true);
        actions.addNewCategory(category, entities, false).then((response) => {
            this.updateCategoriesName(() => {
                this.refreshEntityItems(selectedItemsObjects);
                this.showSuccessPopup("Entities_Review_UIText_reviewCompanies.categoryAssignmentSuccessful")
                this.clearSelections();
            });
            this.closeModal();
        }).catch(e => {
            if(e !== 'SpecialErr400') {
                this.showGenericError(e, true);
                this.clearSelections();
            }
            this.setItemsLoading(selectedItemsObjects, false);
        })
    }

    handleBulkActive() {
        const selectedItemsObjects = this.state.selectedItems.map(item => item.object).filter(item => !item.active);
        this.setItemsLoading(selectedItemsObjects, true);
        return api.activateEntities(selectedItemsObjects.map(item => item.id)).then(() => {
            this.updateItems(selectedItemsObjects.map(item => ({ ...item, active: true})));
            if (this.loadParams.filters.active === "non-active") {
                this.reloadTable();
            } else {
                this.setItemsLoading(selectedItemsObjects, false);
            }
            this.showSuccessPopup('Entities_Review_UIText_reviewCompanies.selectedCompaniesActivated');
        }).catch((e) => {
            this.clearSelections();
            this.showGenericError(e, true)
        })
    }

    displayDownloadModal = () => {
        const hasAllItemsSelected = this.state.selectedItems.length === this.state.totalCount;
        const activeModal = (
            <EntitiesDownloadModal
                isModalLoading={false}
                primaryAction={this.handleBulkDownload}
                secondaryAction={this.closeModal}
                hasAllItemsSelected={hasAllItemsSelected}
            />
        );
        this.setState({ activeModal });
    };

    handleBulkDownload = downloadOption => {
        const selectedEntityIds = this.state.selectedItems.map(item => item.object.id);
        const date = new Date();
        const uiDate = dateFormat(date, "dd mmm yyyy");
        const uiTime = dateFormat(date, "HH:MM");
        const downloadParams = {
            actionPath: ENTITIES_DOWNLOAD_REPORT_ENDPOINT,
            queryParams: {uiDate, uiTime},
            onDownloadComplete: this.handleDownloadComplete
        };

        downloadParams.queryParams = downloadOption === ENTITIES_DOWNLOAD_OPTIONS.ALL_ENTITIES
            ? {downloadAllEntities: true, ...downloadParams.queryParams}
            : {selectedEntityIds, ...downloadParams.queryParams};

        this.setState({
            downloadParams
        })
    };

    handleDownloadComplete() {
        this.setState({ downloadParams: false });
        this.showSuccessPopup("Entities_Download_UIText_successfullyDownloadedReport");
        this.closeModal();
    }

    unassignCategoryFromCompany(entity, category) {
        this.setItemLoading(entity, true);
        return api.unassignCategoryFromEntity(entity.id, category.id).then(() => {
            this.showSuccessPopup("Entities_Review_UIText_reviewCompanies.categoryUnassignmentSuccessful");
            if (this.loadParams.filters.categoryIdFilter === category.id) {
                this.reloadTable();
            } else {
                this.refreshEntityItems([entity])
            }
        }).catch(e => {
            this.showGenericError(e, true);
        })
    }

    refreshEntityItems(entities) {
        if (this.state.selectedItems.length > ENTITIES_HOT_UPDATE_LIMIT) {
            this.reloadTable();
        } else {
            api.specific(entities.map(entity => entity.id)).then(updatedEntities => {
                this.updateCategoriesName(() => {
                    this.updateItems(updatedEntities);
                    this.setItemsLoading(updatedEntities, false);
                })
            }).catch(e => {
                this.showGenericError(e, true);
            })
        }
    }

    toggleCheckCategoryBeforeDeleteConfirmation(props) {
        props.secondaryAction = this.closeModal;
        this.setState({ activeModal: null }, () => {
            this.setState({ activeModal: <ModalReviewPageRemovedCategoryIsOrphaned {...props} /> });
        });
    }

    toggleCheckCategoryBeforeDeleteWithTableConfirmation(props) {
        props.secondaryAction = this.closeModal;
        this.setState({ activeModal: null }, () => {
            this.setState({ activeModal: <ModalReviewPageRemovedCategoryIsOrphanedLinked {...props} /> });
        })
    }

    showGenericError(e, reload) {
        if (reload) { // for entities also reload the categories, just to be sure
            this.updateCategoriesName(() => {
                super.showGenericError(e, reload)
            });
        } else {
            super.showGenericError(e, reload);
        }
    }

    /**
     * Overriding setItemsLoading, if too many items are selected, just refresh the results because it can get too heavy on some clients
     * @param items
     * @param loadingState
     */
    setItemsLoading(items, loadingState) {
        if (items.length > ENTITIES_HOT_UPDATE_LIMIT) {
            if (loadingState === false) {
                this.reloadTable();
            }
        } else {
            super.setItemsLoading(items, loadingState);
        }
    }

    render() {
        const inactiveSelectedItems = this.state.selectedItems.filter(item => !item.object.active)
        const buttons = <div className="table-buttons">
            <BulkActivateButton action={this.handleBulkActive} disabled={inactiveSelectedItems.length === 0}/>
            <DeleteButton action={this.handleBulkDelete} disabled={this.state.selectedItems.length === 0}/>
            <PermissionContext.Provider value={{canEdit: userHas(permissions.entities.edit)}}>
                <BulkDownloadButton action={this.displayDownloadModal}
                                    disabled={this.state.selectedItems.length === 0}
                />
            </PermissionContext.Provider>
            <AssignToCategory categories={this.state.categories}
                              disabled={this.state.selectedItems.length === 0}
                              onSave={this.handleAssignCategory}/>
        </div>;

        return <PermissionContext.Provider value={{ canEdit: userHas(permissions.entities.edit) }}>
            <div className="manage-entities listing-page standard-table">
                <ListingPageHeader
                    location={'/create-new-entity'}
                    buttonMessageId={"HeaderFooterNav_CoreFunctionality_Dropdown_nav.companies.createNewEntity"}/>

                <div className="entities-table selectable-table">
                    <Table {...this.getTableProps()}
                           selectedItems={sortBy(this.state.selectedItems, item => item.companyTitle.props.value.toLowerCase())}
                           actions={buttons}
                           filters={this.getFilters()}
                           fullScreen/>
                </div>
                {this.state.activeModal && this.state.activeModal}
            </div>
            {this.state.downloadParams &&
                <FileDownload {...this.state.downloadParams}/>
            }
        </PermissionContext.Provider>;
    }
}

export default injectIntl(EntityListing);


// WEBPACK FOOTER //
// ./src/scripts/pages/Entities/EntityListing.jsx